import { render, staticRenderFns } from "./AcaoObjetoNlPreview.vue?vue&type=template&id=0a9531c6&scoped=true"
import script from "./AcaoObjetoNlPreview.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoNlPreview.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoNlPreview.vue?vue&type=style&index=0&id=0a9531c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9531c6",
  null
  
)

export default component.exports